import React from "react";
import { withStyles } from "@mui/styles";

import PageWrapper from "../../components/pageWrapper/PageWrapper";
// import DialogModal from "../../components/dialogModal/DialogModal";
// import Section from "../../components/section/Section";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
});

function AccountSettingsPage() {
  return (
    <PageWrapper showHeader={true} showSidebar={true} title="Club settings">
      {/* <DialogModal /> */}
    </PageWrapper>
  );
}

export default withStyles(styles)(AccountSettingsPage);
